import { createActions, createReducer } from 'reduxsauce'

import TransfFinAdmService from '../../servicos/TransfFinAdmService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTransfFinAdmInicio: [],
    buscaTransfFinAdmSucesso: ['transfFinAdm'],
    buscaTransfFinAdmErro: ['erro'],
    setSelecionadoPorOrgaoSucesso: ['selecionado'],
    setTransfFinAdmEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaTransfFinAdm = filtro => {
    return dispatch => {
        dispatch(Creators.buscaTransfFinAdmInicio())
        let serv = new TransfFinAdmService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaTransfFinAdmSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTransfFinAdmErro(error)))
    }
}

const buscaTransfFinAdmInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTransfFinAdmErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTransfFinAdmSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.transfFinAdm.resultado, dataAtualizacaoDados: action.transfFinAdm.dataAtualizacaoDados, carregando: false }
}

const setSelecionadoPorOrgaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

const setTransfFinAdmEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TRANSF_FIN_ADM_INICIO]: buscaTransfFinAdmInicio,
    [Types.BUSCA_TRANSF_FIN_ADM_ERRO]: buscaTransfFinAdmErro,
    [Types.BUSCA_TRANSF_FIN_ADM_SUCESSO]: buscaTransfFinAdmSucesso,
    [Types.SET_SELECIONADO_POR_ORGAO_SUCESSO]: setSelecionadoPorOrgaoSucesso,
    [Types.SET_TRANSF_FIN_ADM_ESTADO_DT]: setTransfFinAdmEstadoDT,
})
